export const addToWaiting = (id: number) => ({
  type: "@saga/ADD_TO_WAITING",
  payload: id,
});
